import React, { useState, useCallback, useContext } from "react";
import PropTypes from "prop-types";
import { PropertyStoreContext } from "../../contexts/PropertyStoreContext";
import chevronRightIcon from "../../assets/img/chevron_right_sm.svg";
import mailContactIcon from "../../assets/img/mail-contact.svg";
import { PROPERTY_CONFIG_HEADER } from "./constants";
import ContactUsModal from "./ContactUsModal";

const PropertyConfigHeader = ({ title }) => {
  const { selectedProperty } = useContext(PropertyStoreContext);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleContactUs = useCallback(() => {
    setIsContactModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsContactModalOpen(false);
  }, []);

  return (
    <>
      <header className="property-config-page__header">
        <div className="property-config-page__header-left">
          <nav
            aria-label="Breadcrumb"
            className="property-config-page__breadcrumb"
          >
            <span className="property-config-page__breadcrumb-text">
              {PROPERTY_CONFIG_HEADER.BREADCRUMB_LABEL}
            </span>
            <img
              src={chevronRightIcon}
              alt=""
              className="property-config-page__breadcrumb-chevron"
            />
          </nav>
          <h1 className="property-config-page__title">{title}</h1>
        </div>
        <div className="property-config-page__header-right">
          <p className="property-config-page__help-text">
            {PROPERTY_CONFIG_HEADER.HELP_TEXT}
          </p>
          <button
            type="button"
            className="property-config-page__contact-btn"
            onClick={handleContactUs}
          >
            <img
              src={mailContactIcon}
              alt=""
              className="property-config-page__contact-btn-icon"
            />
            <span>{PROPERTY_CONFIG_HEADER.CONTACT_BUTTON_TEXT}</span>
          </button>
        </div>
      </header>
      <ContactUsModal
        open={isContactModalOpen}
        onClose={handleCloseModal}
        propertyId={selectedProperty?.propertyId}
      />
    </>
  );
};

PropertyConfigHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PropertyConfigHeader;
